import { IonSkeletonText } from '@ionic/react'
import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'
import { useState } from 'react'
import { TimeShiftItem } from './TimeShiftItem'
import type { TimesheetShift } from './types'

/** "History" block: expandable shift list + skeleton/empty states. */
export const TimeSheetHistory = ({
  shifts,
  fetching,
}: {
  shifts: TimesheetShift[]
  fetching: boolean
}) => {
  const { _ } = useLingui()
  const [expandedShifts, setExpandedShifts] = useState<Set<number>>(
    () => new Set(),
  )

  const toggleShift = (id: number) =>
    setExpandedShifts((prev) => {
      const next = new Set(prev)
      if (next.has(id)) {
        next.delete(id)
      } else {
        next.add(id)
      }
      return next
    })

  return (
    <div className='tc-history-block'>
      <div className='tc-history-heading'>{_(msg`History`)}</div>
      {fetching ? (
        <IonSkeletonText animated style={{ height: '48px' }} />
      ) : shifts.length === 0 ? (
        <div className='tc-empty-state'>
          <p>{_(msg`No time cards match the selected date range.`)}</p>
        </div>
      ) : (
        <div className='tc-history-list'>
          {shifts.map((shift) => (
            <TimeShiftItem
              key={shift.id}
              shift={shift}
              expanded={expandedShifts.has(shift.id)}
              onToggle={() => toggleShift(shift.id)}
            />
          ))}
        </div>
      )}
    </div>
  )
}
